import { Stack } from '@fluentui/react';

import { Body1Strong, Button } from '@fluentui/react-components';
import { Dismiss20Regular, Save20Regular, PersonEditRegular } from "@fluentui/react-icons";

// Define the types for props
interface ProfileDrawerHeaderProps {
    userData: {
        firstName: string;
        lastName: string;
    };
    setOverlayOpen: (open: boolean) => void; 
    usernameAvatar: () => JSX.Element;
}

const ProfileDrawerHeader: React.FC<ProfileDrawerHeaderProps> = ({ userData, setOverlayOpen, usernameAvatar }) => {
  return (
    <>
			<Stack horizontal >
				<Stack horizontalAlign="start" horizontal tokens={{ childrenGap: 20, padding: 5 }} verticalAlign="center">
					{usernameAvatar()}
					<Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 5 }}>
						<Body1Strong> {userData.firstName} </Body1Strong>
						<Body1Strong> {userData.lastName} </Body1Strong>
					</Stack>
				</Stack>
				<Stack tokens={{ childrenGap: 10 }} horizontalAlign="end" grow verticalAlign="center">
					{/* <Button shape="circular"appearance="subtle" aria-label="Close" icon={<Dismiss20Regular />} onClick={() => { setOverlayOpen(false); }} /> */}
				</Stack>
			</Stack>
		</>
  )
}

export default ProfileDrawerHeader